export default __webpack_public_path__ + "static/media/Control_4_Thermocycler.9d6b48c9.svg";